export default __webpack_public_path__ + "static/AC_Slipmat_Full-a475d4478bb4c5366912dd0684779087.jpg";